<template>
  <component :is="component == 'add' ? 'LogisticsExceptionAdd' : 'LogisticsExceptionFollow'" />
</template>
<script>
import LogisticsExceptionAdd from './components/LogisticsExceptionAdd.vue'
import LogisticsExceptionFollow from './components/LogisticsExceptionFollow.vue'
export default {
  components: {
    LogisticsExceptionAdd,
    LogisticsExceptionFollow
  },
  data() {
    return {
      component: 'add'
    }
  },
  watch: {
    '$route.query': {
      handler(nv) {
        this.initPage(nv)
      },
      deep: true
    }
  },
  created() {
    this.initPage(this.$route.query)
  },
  methods: {
    initPage({ id, status }) {
      if (id) {
        if (status === 'E001' || !status) {
          this.component = 'add'
        } else {
          this.component = 'detail'
        }
      } else {
        this.component = 'add'
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/logisticsExceptionHandling.vue